import { Plugin } from '@ckeditor/ckeditor5-core';
import InsertStatInsightCommand from './stat-insight-command';
export default class StatInsightEditing extends Plugin {
    init() {
        this.editor.commands.add('insertStatInsight', new InsertStatInsightCommand(this.editor));
        this._defineSchema();
        this._defineConverters();
        this._definePostFixer();
    }
    _defineSchema() {
        const schema = this.editor.model.schema;
        schema.register('statInsight', {
            allowWhere: '$block',
            allowContentOf: '$root',
        });
    }
    _defineConverters() {
        const conversion = this.editor.conversion;
        conversion.for('upcast').elementToElement({
            model: 'statInsight',
            view: 'x-stat-insight',
        });
        conversion.for('dataDowncast').elementToElement({
            model: 'statInsight',
            view: 'x-stat-insight',
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'statInsight',
            view: {
                name: 'div',
                classes: 'stat-insight',
            },
        });
    }
    _definePostFixer() {
        const editor = this.editor;
        const schema = editor.model.schema;
        // Postfixer which cleans incorrect model states connected with statInsights.
        editor.model.document.registerPostFixer((writer) => {
            const changes = editor.model.document.differ.getChanges();
            for (const entry of changes) {
                if (entry.type == 'insert') {
                    const element = entry.position.nodeAfter;
                    if (!element) {
                        // We are inside a text node.
                        continue;
                    }
                    if (element.is('element', 'statInsight') && element.isEmpty) {
                        // Added an empty statInsight - remove it.
                        writer.remove(element);
                        return true;
                    }
                    else if (element.is('element', 'statInsight') &&
                        !schema.checkChild(entry.position, element)) {
                        // Added a statInsight in incorrect place - most likely inside another statInsight. Unwrap it
                        // so the content inside is not lost.
                        writer.unwrap(element);
                        return true;
                    }
                    else if (element.is('element')) {
                        // Just added an element. Check its children to see if there are no nested statInsights somewhere inside.
                        const range = writer.createRangeIn(element);
                        for (const child of range.getItems()) {
                            if (child.is('element', 'statInsight') &&
                                !schema.checkChild(writer.createPositionBefore(child), child)) {
                                writer.unwrap(child);
                                return true;
                            }
                        }
                    }
                }
                else if (entry.type == 'remove') {
                    const parent = entry.position.parent;
                    if (parent.is('element', 'statInsight') && parent.isEmpty) {
                        // Something got removed and now statInsight is empty. Remove the statInsight as well.
                        writer.remove(parent);
                        return true;
                    }
                }
            }
            return false;
        });
    }
}
